import React, { useEffect, useState } from 'react';
import './Preloader.css';

function Preloader({ onComplete }) {
  const [progress, setProgress] = useState(0);
  const [hidden, setHidden] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    let current = 0;
    const tick = setInterval(() => {
      const remaining = 100 - current;
      const increment = Math.max(0.6, remaining * 0.08);
      current = Math.min(100, current + increment);
      setProgress(Math.round(current));

      if (current >= 100) {
        clearInterval(tick);
        setTimeout(() => {
          setHidden(true);
          setTimeout(() => {
            setDone(true);
            if (onComplete) onComplete();
          }, 500);
        }, 200);
      }
    }, 35);

    return () => clearInterval(tick);
  }, [onComplete]);

  if (done) return null;

  return (
    <div className={`preloader ${hidden ? 'preloader--hidden' : ''}`}>
      <div className="preloader__content">
        <div className="preloader__logo-wrap">
          <img
            src="/logo.png"
            alt="Mind Spa"
            className="preloader__logo"
          />
        </div>

        <div className="preloader__brand">Mind Spa</div>
        <div className="preloader__byline">
          by Manju Agrawal
        </div>

        <div className="preloader__bar-track" role="progressbar" aria-valuenow={progress} aria-valuemin={0} aria-valuemax={100}>
          <div className="preloader__bar-fill" style={{ width: `${progress}%` }} />
        </div>
      </div>
    </div>
  );
}

export default Preloader;
